import { ReportSdk } from 'lib-klab-sdks';
import {
    ConnectivityReportItem,
    ConnectivityReportMetadata,
    ConnectivityReportResponse,
} from '../../../domain/models/reports/connectivity-report.model';

export function mapSdkConnectivityMetadataToDomain(
    metadata?: ReportSdk.ConnectivityResponseMetadata,
): ConnectivityReportMetadata {
    return {
        employeeId: metadata?.employeeId ?? 0,
        dateRange: {
            startDate: metadata?.dateRange?.startDate ?? '',
            endDate: metadata?.dateRange?.endDate,
        },
        scheduledTotalSeconds: metadata?.scheduledTotalSeconds ?? 0,
        holidayProductiveSeconds: metadata?.holidayProductiveSeconds ?? null,
        holidayCount: metadata?.holidayCount ?? 0,
        // Se propaga el null: sin jornada esperada no hay porcentaje que mostrar.
        productivityPercentage: metadata?.productivityPercentage ?? null,
    };
}

export function mapSdkConnectivityItemToDomain(
    item: ReportSdk.ConnectivityItem,
): ConnectivityReportItem {
    return {
        employeeId: item.employeeId,
        date: item.date,
        startedAt: item.startedAt,
        endedAt: item.endedAt,
        totalSeconds: item.totalSeconds,
        officeSeconds: item.officeSeconds,
        activeSeconds: item.activeSeconds,
        productiveSeconds: item.productiveSeconds,
        unproductiveSeconds: item.unproductiveSeconds,
        neutralSeconds: item.neutralSeconds,
        totalWorkDaySeconds: item.totalWorkDaySeconds,
        productivityPercentage: item.productivityPercentage,
        bestTimeDay: item.bestTimeDay,
        // El motivo se propaga tal cual: es lo que deja a la vista decir
        // "No laborable" en lugar de un guion que significa tres cosas.
        noExpectedReason: item.noExpectedReason ?? null,
    };
}

export function mapSdkConnectivityResponseToDomain(
    resp: ReportSdk.ConnectivityResponse,
): ConnectivityReportResponse {
    return {
        metadata: mapSdkConnectivityMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkConnectivityItemToDomain),
    };
}